var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryBackdrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1287,
    viewBox: "0 0 1920 1287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_692_45",
    x: -201.793,
    y: 0,
    width: 2411.36,
    height: 1287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_692_45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_45",
    x1: -2,
    y1: 831,
    x2: 1918,
    y2: 831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8085FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_692_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.224 865H-1.79297V678H188.207V741H504.224V854H736.732V780H981.802V731H1289.46V724H1572.44V580H1858.56V200H2009.56V627H1918V822H1635.02V984H1327.37V1010H1082.3V1087H736.732V1081H446.705V1010H158.224V865Z",
    fill: "url(#paint0_linear_692_45)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "                 0,0;                 -80,50;                 -30,120;                 40,60;                 80,-40;                 30,-100;                 -40,-60;                 -80,50;                 0,0",
    dur: "7.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2009.56 627H1918V822H1635.02V984H1327.37V1010H1082.3V1087H736.732V1081H446.705V1010H158.224V865H-1.79297V678H188.207V741H504.224V854H736.732V780H981.802V731H1289.46V724H1572.44V580H1858.56V200H2009.56V627Z",
    fill: "url(#paint0_linear_692_45)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "                 0,0;                 100,-70;                 50,-140;                 -60,-80;                 -100,50;                 -40,120;                 60,80;                 100,-70;                 0,0",
    dur: "8.75s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M981.802 731H1289.46V724H1572.44V580H1858.56V200H2009.56V627H1918V822H1635.02V984H1327.37V1010H1082.3V1087H736.732V1081H446.705V1010H158.224V865H-1.79297V678H188.207V741H504.224V854H736.732V780H981.802V731Z",
    fill: "url(#paint0_linear_692_45)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "                 0,0;                 -40,80;                 -80,20;                 -20,-60;                 60,-100;                 80,-20;                 20,60;                 -40,80;                 0,0",
    dur: "10s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryBackdrop);
export default __webpack_public_path__ + "static/media/category_backdrop.3d5c3158c3ec456b16a339713691f002.svg";
export { ForwardRef as ReactComponent };